import * as type from './types'
import * as api from '../api'

export const setUser = ({ commit }, user) => {
  commit(type.SET_LOGGED_IN, user !== null)
  if (user) {
    commit(type.SET_USER, {
      displayName: user.displayName,
      email: user.email,
    })
    commit(type.SET_USER_TOKEN, {
      idToken: user.ma,
      expiration: +user.metadata.b + 3600000, /* add 1 hour to token issue time */
    })
  } else {
    commit(type.SET_USER, null)
  }
}

export const updateSessionToken = ({ commit }, sessionConfig) => {
  commit(type.SET_USER_TOKEN, {
    idToken: sessionConfig.idToken,
    expiration: +sessionConfig.issueTimestamp + 3600000, /* add 1 hour to token issue time */
  })
}

export const fetchOrg = async ({ commit }, user) => {
  let email = user.data.email
  let token = user.data.idToken
  let res = await api.getOrg(token, email)
  let org = await res.json()
  return commit(type.SET_ORG, org)
}